import React from 'react'
import { useTranslation } from 'react-i18next'

const Footer = ({ restaurantInfo }) => {
    const { t } = useTranslation()

    const VerticalDivider = () => <span style={{ fontSize: '20px' }}>|</span>

    return (
        <div className="app-footer">
            <div className="contact-info container-fluid container-xl">
                <label>{t('footer.lbContact')}</label>
                <span>
                    <i className="mr-2 fas fa-phone" />
                    {restaurantInfo.hotline}
                </span>
                <VerticalDivider />
                <span>
                    <i className="mr-2 fas fa-envelope" />
                    {restaurantInfo.settings?.email_shop || ''}
                </span>
                <VerticalDivider />
                <span>
                    <i className="mr-2 fas fa-map-marker-alt" />
                    {`${restaurantInfo.address} ${restaurantInfo.city}`}
                </span>
            </div>
            <div className="imprint">
                <div className="container-fluid container-xl">
                    <div className="imprint-label">{t('footer.lbImprint')}</div>
                    {restaurantInfo?.settings?.imprint}
                </div>
            </div>
            <div className="copyright">
                {t('footer.lbCopyright', {
                    someone: restaurantInfo.restaurantName,
                })}
            </div>
        </div>
    )
}

export default Footer
